<template>
  <grid-container-fi>
    <div
      class="product-detail-accordions-fi fi-col-start-1 fi-col-end-13 lg:fi-col-start-2 lg:fi-col-end-12"
    >
      <accordion-benefits-description-fi
        :catalog-data="catalogData"
        is-detail-page
      />
      <accordion-learning-targets-fi
        v-if="isFite"
        :catalog-data="catalogData"
      />
      <accordion-content-fi
        v-if="isFite"
        :catalog-data="catalogData"
      />
      <accordion-application-authorisation-fi :catalog-data="catalogData" />
      <accordion-assembly-instructions-fi
        ref="assembly-instructions"
        :catalog-data="catalogData"
      />
      <accordion-technical-details-fi :catalog-data="catalogData" />

      <accordion-performance-data-fi :catalog-data="catalogData" />

      <accordion-document-downloads-fi
        ref="document-downloads"
        :tab-hash="initDocumentDownloadsTab"
        :catalog-data="catalogData"
      />
    </div>
  </grid-container-fi>
</template>

<script setup lang="ts">
import { getCurrentInstance, onMounted, ref } from 'vue';

import setupAccordion from '@/components/atoms/accordion/setupAccordion';
import AccordionApplicationAuthorisationFi from '@/components/catalog-accordions/accordion-application-authorisation/AccordionApplicationAuthorisationFi.vue';
import AccordionAssemblyInstructionsFi from '@/components/catalog-accordions/accordion-assembly-instructions/AccordionAssemblyInstructionsFi.vue';
import AccordionBenefitsDescriptionFi from '@/components/catalog-accordions/accordion-benefits-description/AccordionBenefitsDescriptionFi.vue';
import AccordionContentFi from '@/components/catalog-accordions/accordion-content/AccordionContentFi.vue';
import AccordionDocumentDownloadsFi from '@/components/catalog-accordions/accordion-document-downloads/AccordionDocumentDownloadsFi.vue';
import AccordionLearningTargetsFi from '@/components/catalog-accordions/accordion-learning-targets/AccordionLearningTargetsFi.vue';
import AccordionPerformanceDataFi from '@/components/catalog-accordions/accordion-performance-data/AccordionPerformanceDataFi.vue';
import AccordionTechnicalDetailsFi from '@/components/catalog-accordions/accordion-technical-details/AccordionTechnicalDetailsFi.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';

defineOptions({ name: 'ProductDetailAccordionFi' });

withDefaults(
  defineProps<{
    catalogData?: any;
  }>(),
  {
    catalogData: () => ({}),
  },
);

const instance = getCurrentInstance();

setupAccordion();

const initDocumentDownloadsTab = ref<string | null>(null);

onMounted(() => {
  let hash = window.location.hash.replace('#', '');
  if (hash) {
    if (hash.includes('document-downloads')) {
      const splittedHash = hash.split('+');
      hash = splittedHash[0];
      initDocumentDownloadsTab.value = splittedHash[1];
    }

    const refEl = (instance?.refs as Record<string, any>)?.[hash];
    if (refEl) {
      setTimeout(() => {
        refEl.openAccordion();
        history.replaceState(null, '', ' ');
      }, 100);
    }
  }
});
</script>
